import React from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

function ArrowDown(props: SvgIconProps) {
  return (
    <SvgIcon
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.8">
        <path d="M15 8.00733L10 13.0073L5 8.00732" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </SvgIcon>
  )
}

export default ArrowDown